import { render, staticRenderFns } from "./EditTenant.vue?vue&type=template&id=641fe9a0"
import script from "./EditTenant.vue?vue&type=script&lang=ts"
export * from "./EditTenant.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports